import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Modal, Form, Divider, Input, Select, Switch } from 'antd'

import { EnhancedTable } from '../../../components/table'

import * as usersActions from './actions'
import * as rolesActions from '../Roles/actions'
import * as organisationsActions from '../Organisations/actions'
import { isoToPrettyDate} from '../../../functions'
import { EditInput, EditSelect } from '../../../components/table'
import { ItemsTransfer } from '../../../components/ItemsTransfer'

import _ from 'lodash'

const Option = Select.Option;

export class UsersTable extends React.Component{

    state = {
        newUserModalVisible : false,
        rolesEditorVisible : false,
        editRoles : [],
        isSystemUser:false,

    }

    componentWillMount(){
        if (this.props.user._links['users']) {
            this.props.getUsers(this.props.user._links['users'].href)
        }
        if (this.props.user._links['allRoles']) {
            this.props.getRoles(this.props.user._links['allRoles'].href)
        }
        if (this.props.user._links['organisations']) {
            this.props.getOrganisations(this.props.user._links['organisations'].href)
        }
    }

    showNewUserModal = ()=>{
        this.setState({
            newUserModalVisible: true
        })
    }

    openRolesEditor= (e, roles) => {
        this.setState({
            selectedUser : e,
            rolesEditorVisible : true,
            editRoles :e._embedded.roles
        })
    }

    closeRolesEditor= (e) => {
        this.setState({
            rolesEditorVisible : false,
        })
    }

    updateRoles = (e) => {
        // we need to remove any roles that aren't in the new roles list and
        // add any roles that are in the list but the user doesn't have yet
        
        const currentRoles = this.state.selectedUser._embedded.roles
        const newRoles = this.state.editRoles
        const changes = _.xor(currentRoles , newRoles)
        _.forEach(changes, changedRole => {
            if (_.includes(currentRoles, changedRole)) {
                // we have this role so we remove it
                this.props.removeRoleFromUser(this.state.selectedUser._links.roles.href, changedRole)
            }
            else { 
                // we don't have this role so we add it
                this.props.addRoleToUser(this.state.selectedUser._links.roles.href, changedRole)
            }
        })
        this.closeRolesEditor()
    }

    handleRolesChange = (roles) => {
        this.setState ({
            editRoles :roles
        })
    }


    createNewUser = (e)=>{
        // validate the form and call the api

        e.preventDefault();
        this.props.form.validateFields((err, values) => {
          if (!err) {
            const type = this.state.isSystemUser?'System account':'User'
            const newUser = {
                firstName : values.firstName,
                name: values.name,
                type : type,
                description : values.description,
                emailAddress: values.emailAddress,
                organisationWss : values.organisationWss,
                requestUrl : e.target.baseURI.replace('/admin/users', ''),
            }
            if (this.state.isSystemUser) {
                
                this.props.createNewUser(this.props.user._links['users'].href, newUser)
            }
            else {
                this.props.createNewUser(this.props.user._links['user.invite'].href, newUser)
            }
            this.closeNewUserModal()
        }
        });    
    }
    
    closeNewUserModal = ()=>{
        this.props.form.resetFields()
        this.setState({
            newUserModalVisible: false,
            isSystemUser : false
        })
    }


    render(){
        const { items, updateUser, deleteUser, reinviteUser } = this.props
        const FormItem = Form.Item
        const { getFieldDecorator } = this.props.form

        const canAdd =  _.includes(this.props.user._embedded.permissions, 'users.create')
        const canEdit =  _.includes(this.props.user._embedded.permissions, 'user.update')
        const canDelete =  _.includes(this.props.user._embedded.permissions, 'user.delete')
        const canReinvite = _.includes(this.props.user._embedded.permissions, 'user.invite')
        const columns = [
            {
            title: 'First name',
            dataIndex: '_embedded.firstName',
            key: 'firstName',
            render: (text, record) =>  
            {return canEdit?<EditInput 
                onChange={ value => 
                    updateUser( record._links.self.href, { ...record._embedded, firstName : value })
                } 
                value={text} 
                key={record._embedded.webSafeString} >
                {text}
            </EditInput> : <React.Fragment>{text}</React.Fragment>}
        }, 
        {
            title: 'Last name',
            dataIndex: '_embedded.name',
            key: 'name',
            render: (text, record) =>  
            {return canEdit?<EditInput 
                onChange={ value => 
                    updateUser( record._links.self.href, { ...record._embedded, name : value })
                } 
                value={text} 
                key={record._embedded.webSafeString} >
                {text}
            </EditInput> : <React.Fragment>{text}</React.Fragment>}
       },
        {
            title: 'Roles',
            dataIndex: '_embedded.roles',
            key: 'roles',
            render: (text, record) => 
            <React.Fragment>
                 <a onClick={ e => { e.preventDefault(); this.openRolesEditor(record) }}>{_.size(record._embedded.roles) } roles </a>
            </React.Fragment>

        },
        {
            title: 'Email',
            dataIndex: '_embedded.emailAddress',
            key: 'emailAddress',
            render: (text, record) =>  
            {return canEdit?<EditInput 
                onChange={ value => 
                    updateUser( record._links.self.href, { ...record._embedded, emailAddress : value })
                } 
                value={text} 
                key={record._embedded.webSafeString} >
                {text}
            </EditInput> : <React.Fragment>{text}</React.Fragment>}
        },
        {
            title: 'Auth0 Id',
            dataIndex: '_embedded.userId',
            key: 'id',
        },
        {
            title: 'Status',
            dataIndex: '_embedded.userStatus',
            key: 'userStatus',
        },
        {
            title: 'Account type',
            dataIndex: '_embedded.type',
            key: 'type',
        },
        {
            title: 'Organisation',
            dataIndex: '_embedded.organisationWss',
            key: 'organisationWss',
            render: (text, record) =>  
            {
                if (canEdit) {
                return <EditSelect
                    style={{ width: '100%' }}
                    values = {_.map(this.props.organisations, (value, key)=> {
                        return {value:value._embedded.webSafeString,
                        label : value._embedded.name}
                    })
                    }   
                    value = {text}
                onChange={ value => 
                    updateUser( record._links.self.href, { ...record._embedded, organisationWss : value })
                } 
                >
                {/* {_.map(this.props.organisations, (value, key)=>{
                    return (<Option key={value._embedded.webSafeString}>{value._embedded.name} ({value._embedded.code})</Option> )  
                })} */}

                </EditSelect>
                }
                else {
                const org = _.find(this.props.organisations, org => {return org._embedded.webSafeString=== text})
                if (org) {
                    return (<React.Fragment>{org._embedded.name}</React.Fragment> )
                }
                }
               
            }
        },
        {
            title:'Last login',
            dataIndex :'_embedded.lastLoginDate',
            key :'lastLoginDate',
            render: (text) =>  
            <React.Fragment>{text?isoToPrettyDate(text):'-'}</React.Fragment> 
        },
        {
            title: 'Action',
            key: 'action',
            render: (text, record) => ( 
                <span>
                    {canDelete?(<a href={record._links.self.href} onClick={ e => { e.preventDefault(); deleteUser(e.target.href) }}>Delete</a>):(<div/>)}

                    <Divider type="vertical" />
                    { (record._links.invite && canReinvite)?
                    (<a href={record._links.invite.href} onClick={ e => { e.preventDefault(); reinviteUser(e.target.href) }}>Resend invite</a>)
                    :(<div/>)}
                </span>
            ),
        }] 

        return (
            <div>
                <Modal 
                    title = 'Set up a new user'
                    visible = {this.state.newUserModalVisible}
                    onOk ={this.createNewUser}
                    okText = {this.state.isSystemUser?'Create new system account':'Create new user and send invite email'}
                    onCancel = {this.closeNewUserModal}
                >
                    <div>
                        The new user will be sent an invite email, which 
                        contains an activation link. Please ensure 
                        that you use the correct email address.
                    </div>
                    <div> System account <Switch checked={this.state.isSystemUser}
                    onChange={e=>{
                        this.setState({isSystemUser: e})
                    }}
                    />
                    </div>
                    <Form>
                    {this.state.isSystemUser?
                    <React.Fragment>
                    <FormItem label="Name">
                        {getFieldDecorator('name', {
                            rules: [{
                                required: true, message: 'Please input a name to identify this system account',
                            }],
                        })(
                        <Input />
                        )}
                    </FormItem>
                    <FormItem label="Description">
                    {getFieldDecorator('description', {
                    })(
                    <Input />
                    )}
                    </FormItem>
                    </React.Fragment>
                    :   
                    <React.Fragment>
                    <FormItem label="First name">
                        {getFieldDecorator('firstName', {
                            rules: [{
                                required: true, message: 'Please input the new user\'s first name',
                            }],
                        })(
                        <Input />
                        )}
                    </FormItem>
                    <FormItem label="Last name">
                        {getFieldDecorator('name', {
                            rules: [{
                                required: true, message: 'Please input the new user\'s last name',
                            }],
                        })(
                        <Input />
                        )}
                    </FormItem>
                    </React.Fragment>
                    }
                    <FormItem label="E-mail">
                        {getFieldDecorator('emailAddress', {
                            rules: [{
                                type: 'email', message: 'The input is not valid E-mail!',
                            }, {
                                required: true, message: 'Please input the new user\'s email address',
                            }],
                        })(
                        <Input />
                        )}
                    </FormItem>
                    <FormItem label="Organisation this user will belong to">
                        {getFieldDecorator('organisationWss', {
                            rules: [{
                                required: true, message: 'Please select the organisation',
                            }],
                        })(
                            <Select
                            style={{ width: '100%' }}
                            >
                            {_.map(this.props.organisations, (value, key)=>{
                                return (<Option key={value._embedded.webSafeString}>{value._embedded.name} ({value._embedded.code})</Option> )  
                            })}

                            </Select>
                                          )}
                    </FormItem>
                    </Form>
                </Modal>
                <Modal
                    style = {{width : '500px'}}
                    onCancel = {this.closeRolesEditor}
                    onOk = {this.updateRoles}
                    okButtonProps = {{disabled:!canEdit}}
                    visible = {this.state.rolesEditorVisible}
                    title={`Roles (${this.state.selectedUser?this.state.selectedUser._embedded.code:''})`}>
                    <ItemsTransfer 
                        allItems = {this.props.roles}
                        selectedUser = {this.state.selectedUser}
                        disabled = {!canEdit}
                        currentItems = {this.state.selectedUser?this.state.selectedUser._embedded.roles:[]}
                        onChange = {this.handleRolesChange}
                        style = {{maxWidth : '100%'}}
                        listStyle={{
                            width: 210,
                            height: 500,
                        }}
                    /> 
                </Modal>
                    <EnhancedTable 
                        columns={columns} 
                        dataSource={items} 
                        rowKey={ record => record._links.self.href }
                        canCreate={ canAdd }
                        onCreate={ this.showNewUserModal } 
                        pagination
                    />
            </div>
        )
    }
} 

UsersTable =Form.create() (connect(
    state => ({ 
        items: Object.values(state.users.items).sort( (a,b) => {
            return ( a._embedded.name ? b._embedded.name ? a._embedded.name.localeCompare(b._embedded.name) : a._embedded.name : b._embedded.name )
        }),
        organisations : state.organisations?state.organisations.items:[],
        roles : _.map(state.roles?state.roles.items:[], role => {return {key : role._embedded.webSafeString, title :role._embedded.name}}),
        user: state.user.profile,
    }),
    dispatch=>(
        bindActionCreators( { ...organisationsActions, ...usersActions, ...rolesActions }, dispatch )
    )
)(UsersTable))


// WEBPACK FOOTER //
// ./src/App/Admin/User/UsersTable.jsx